export enum CashRegisterItemType {
  Comment = 'COMMENT',
  Discount = 'DISCOUNT',
  Standard = 'STANDARD',
  Surcharge = 'SURCHARGE',
}
